'use strict';

var React = require('react');

var SvgCollectionsMajor = function SvgCollectionsMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.517 4.098a3.75 3.75 0 0 1 2.652-1.098h2.081a2.75 2.75 0 0 1 2.75 2.75v2.289a3.25 3.25 0 0 1-.952 2.298l-4.206 4.206a2.5 2.5 0 0 1-3.536 0l-2.672-2.672a2.75 2.75 0 0 1 0-3.89l3.883-3.883Zm2.652.402a2.25 2.25 0 0 0-1.591.659l-3.883 3.883a1.25 1.25 0 0 0 0 1.768l2.672 2.672a1 1 0 0 0 1.414 0l4.206-4.206a1.75 1.75 0 0 0 .513-1.237v-2.289c0-.69-.56-1.25-1.25-1.25h-2.081Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.75 5.5a.75.75 0 0 1 .75.75v3.029a3.25 3.25 0 0 1-.968 2.313l-4.755 4.692a.75.75 0 1 1-1.054-1.068l4.756-4.692a1.75 1.75 0 0 0 .521-1.245v-3.029a.75.75 0 0 1 .75-.75Z"
  }));
};
SvgCollectionsMajor.displayName = "CollectionsMajor";

exports.SvgCollectionsMajor = SvgCollectionsMajor;
